import React from 'react';
import PropTypes from 'prop-types';
import SpaceTypeInfo from './SpaceTypeInfo';
import SearchField from 'shared-components/reduxForms/fields/SearchField/SearchField';
import { map, get } from 'lodash';
import { Field } from 'redux-form';
import TagError from './TagError';
import { injectIntl, intlShape } from 'react-intl';

const SpaceTypeTaggingField = ({ tags, space, typeTagFieldValue, intl }) => {
  const formatTags = map(tags, tag => {
    return {
      label: tag.display_name,
      value: tag.name
    };
  });

  const spaceId = get(space, 'data._id');

  return (
    <div className="flex column">
      <SpaceTypeInfo />
      <div className="flex">
        <div className="flex-basis-100 flex-basis-60-sm">
          <Field
            name='type_tag'
            component={SearchField}
            options={formatTags}
            isSearchable
            noOptionsMessage={() => <TagError type_tag={typeTagFieldValue} spaceId={spaceId} />}
            placeholder={intl.formatMessage({ id: 'hosting.space_type_tagging_field.placeholder', defaultMessage: 'Enter a type of space' })}
            classNamePrefix="space-type-tagging"
            components={{
              ClearIndicator: () => null
            }}
          />
        </div>
      </div>
    </div>
  );
};

SpaceTypeTaggingField.propTypes = {
  tags: PropTypes.array,
  space: PropTypes.object,
  typeTagFieldValue: PropTypes.string,
  intl: intlShape
};

export default injectIntl(SpaceTypeTaggingField);
